import { configureStore } from '@reduxjs/toolkit';

import rootReducer from '../reducers/reducers';

// Redux Toolkit v2 includes redux-thunk in the default middleware, so it no
// longer needs to be added explicitly (the old `middleware: [thunk]` array is
// also no longer a valid value — middleware must be a Tuple/callback).
export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  // `loaderRXS` intentionally keeps its loaded/expected asset ids in `Set`s
  // (used via `.has()`/`.size`/spread in ScrollToContainer). Sets are not
  // plain-serializable, so exclude those paths from the serializability check
  // instead of flooding the console with false positives.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['loaderRXS.loadedAssets', 'loaderRXS.expectedAssets'],
      },
    }),
});

// https://github.com/reduxjs/redux-toolkit/issues/587
